import { render } from "./EncyclopediaEntryDetail.vue?vue&type=template&id=433a9f9f&scoped=true"
import script from "./EncyclopediaEntryDetail.vue?vue&type=script&lang=js"
export * from "./EncyclopediaEntryDetail.vue?vue&type=script&lang=js"

import "./EncyclopediaEntryDetail.vue?vue&type=style&index=0&id=433a9f9f&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-433a9f9f"]])

export default __exports__